import { CONCEPTS_REQUEST, CONCEPTS_COMPLETE, CONCEPTS_SHOW, CONCEPT_EDIT, CONCEPT_FAIL, CONCEPT_UNITS, CONCEPT_CLEAR } from "../store/config";

const conceptInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q:''
	},
	edit: {
		units:[]
	},
	permissions: [],
	error: undefined,
	message: undefined
};

const concepts = (state = conceptInit,action) => {
	switch (action.type){
		case CONCEPTS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case CONCEPTS_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case CONCEPTS_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case CONCEPT_EDIT:
			return {
				...state,
				edit: {
					...state.edit,
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case CONCEPT_UNITS:
			return {
				...state,
				edit: {
					...state.edit,
					units: action.payload
				},
				timestamp: action.timestamp
			}
		case CONCEPT_CLEAR: {
			return {
				...state,
				...action.payload,
				timestamp: action.timestamp
			}
		}
		case CONCEPT_FAIL:
			return {
				...state,
				isFetching:action.isFetching,
				error:action.error,
				timestamp:action.timestamp
			}
		default:
			return {
				...state
			}
	}
};

export default concepts;




// WEBPACK FOOTER //
// ./src/reducers/concepts.js